import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Task, MappedLookupItem } from "common/types";
import {
  ResourceAdequacyState,
  ConfigModalForm,
  RunConfig,
  MultiSelectItemRA
} from "./types";

const initialState: ResourceAdequacyState = {
  runConfigs: [],
  runConfigToEdit: {},
  task: null,
  modalHeader: "Edit run configuration",
  showSpinner: false,
  configModal: {
    open: false,
    spinner: false,
    title: "",
    isEdit: false,
    scenarios: [],
    scenarioGroups: [],
    partitioning: [],
    form: {
      name: "",
      scenarioNamePrefix: "",
      raMode: null,
      spotWaitTime: null,
      asOfDate: null,
      baseScenarioId: null,
      autoRunIntermediateResultsStage: null,
      drawsNumberFilteringStage: null,
      partitioningModeId: null,
      startDate: null,
      endDate: null,
      lossAdjustmentFactor: null,
      drawsNumberIntermediateResultsStage: null,
      scenariosNumberIntermediateResultsStage: null,
      minVarianceIntermediateResultsStage: 0, //hard coded zero. Task 4676
      scenarioGroupIds: [],
      useSpot: 0,
      isScenarioNamePrefixEditable: false,
      isAsOfDateEditable: false,
      isDrawsNumberFilteringStageEditable: false,
      isStartDateEditable: false,
      isEndDateEditable: false,
      isPartitioningModeIdEditable: false,
      isLossAdjustmentFactorEditable: false,
      isDrawsNumberIntermediateResultsStageEditable: false,
      isScenariosNumberIntermediateResultsStageEditable: false,
      isMinVarianceIntermediateResultsStageEditable: false,
    }
  }
};

const resourceAdequacySlice = createSlice({
  name: "resourceAdequacy",
  initialState,
  reducers: {
    setRunConfigs(state, action: PayloadAction<RunConfig[]>) {
      state.runConfigs = action.payload;
    },
    setRunConfigToEdit(state, action: PayloadAction<Partial<RunConfig>>) {
      state.runConfigToEdit = action.payload;
    },
    setModalHeader(state, action: PayloadAction<string>) {
      state.modalHeader = action.payload;
    },
    setTask(state, action: PayloadAction<Task>) {
      state.task = action.payload;
    },
    toggleSpinner(state, action: PayloadAction<boolean>) {
      state.showSpinner = action.payload;
    },
    openConfigModal(state, action: PayloadAction<{ title: string; isEdit: boolean; form?: Partial<ConfigModalForm> }>) {
      state.configModal.open = true;
      state.configModal.title = action.payload.title;
      state.configModal.isEdit = action.payload.isEdit;
      state.configModal.form = action.payload.form ? { ...state.configModal.form, ...action.payload.form } : state.configModal.form;
    },
    closeConfigModal(state) {
      state.configModal = initialState.configModal;
    },
    toggleModalSpinner(state, action: PayloadAction<boolean>) {
      state.configModal.spinner = action.payload;
    },
    setScenarios(state, action: PayloadAction<MappedLookupItem[]>) {
      state.configModal.scenarios = action.payload;
    },
    setScenarioGroups(state, action: PayloadAction<MultiSelectItemRA[]>) {
      state.configModal.scenarioGroups = action.payload;
    },
    setPartitioning(state, action: PayloadAction<MappedLookupItem[]>) {
      state.configModal.partitioning = action.payload;
    },
    resetState() {
      return initialState;
    }
  }
});

export const actions = resourceAdequacySlice.actions;
export default resourceAdequacySlice.reducer;